<script lang="ts">
  import type { ControlValidator, ValidatorMessages } from "./validators";
  import { createEventDispatcher } from "svelte";
  import { Control, setupControl } from "./controls";

  type TControl = $$Generic<Control<any>>;
  const dispatch = createEventDispatcher<{ change: TControl }>();

  // either set name and validators
  export let name: string = null;
  export let validators: ControlValidator[] = [];
  export let value: any = undefined;
  // ... or bind a control
  export let control: TControl = null;
  export let standalone: boolean = false;
  export let displayName: string = undefined;
  export let errors: ValidatorMessages = undefined;

  let oldValue = value;

  const changes = setupControl<TControl>(Control as any, {
    name,
    validators,
    value,
    control,
    standalone,
    register: !standalone, // never register standalone InputControl becase they register them self if necessary
  });
  $: ctrl = $changes;
  $: ctrl.displayName = `${displayName || ""}`.replace(/\s+\*$/, "");
  $: ctrl.validatorMessages = errors;

  // TODO this change evetn fires on init (change form undefined to init-value)!
  $: if (ctrl.value !== oldValue) {
    dispatch("change", ctrl);
  }

  $: if (value !== oldValue) {
    oldValue = value;
    ctrl.value = value;
  }
</script>

<slot control={ctrl} />
